export default {"src":"/_next/static/media/ic_nav_close.db0a1d21.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};